import { uiOptions } from '@/config'
import humanizeDuration from 'humanize-duration'
import { DateTime, Interval } from 'luxon'

export function getDatesIntervalToHumanReadable(date: Date) {
  const formatted = Interval.fromDateTimes(DateTime.fromJSDate(date), DateTime.now()).toDuration().valueOf()

  return humanizeDuration(formatted, { language: uiOptions().location.language, largest: 2, round: true })
}
